import { cn } from "@/lib/utils"

export interface SpinnerCircleProps {
  className?: string
  variant?: "dark" | "light" | "blue"
}

export default function SpinnerCircle({
  className,
  variant = "dark",
}: SpinnerCircleProps) {
  return (
    <div
      className={cn(
        "w-7 h-7 border-[3px] border-transparent rounded-full animate-spin",
        variant === "dark" && "border-t-white border-r-white",
        variant === "light" && "border-t-black border-r-black",
        variant === "blue" && "border-t-blue border-r-blue",
        className
      )}
    />
  )
}
